<template>
  <div id="BenutzerHeader" class="bg-secondary py-2 mb-4 top-space">
    <h1 class="text-white">Einstellungen</h1>
  </div>
</template>

<script>
export default {
  name: 'BenutzerHeader'
}
</script>

<style scoped>
  @media screen and (max-width: 576px) {
    #BenutzerHeader {
      margin-top: 64px;
      padding-top: 10px !important;
      padding-bottom: 10px !important;
    }

    h1 {
      font-size: 1.8rem;
    }
  }

  @media screen and (min-width: 577px) and (max-width: 992px) {
    #BenutzerHeader {
      margin-top: 100px;
      padding-top: 13px !important;
      padding-bottom: 13px !important;
    }

    h1 {
      font-size: 2rem;
    }
  }
</style>
